import { createFrozenSelector } from '../../rewrite/utils/createFrozenSelector';
const getOverlaySlice = state => state.overlay;
export const getModalType = createFrozenSelector([getOverlaySlice], slice => slice.modalType);
export const getModalData = createFrozenSelector([getOverlaySlice], slice => slice.modalData);
export const getPanelType = createFrozenSelector([getOverlaySlice], slice => slice.panelType);
export const getPanelData = createFrozenSelector([getOverlaySlice], slice => slice.panelData);